var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 84,
    viewBox: "0 0 83 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -2.40413,
    y: 2.40413,
    width: 78.1917,
    height: 78.1917,
    rx: 39.0959,
    transform: "matrix(-1 0 0 1 78.1917 0.740234)",
    stroke: "black",
    strokeWidth: 4.80827
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 39.9927C57.5174 39.9927 58.7476 41.2228 58.7476 42.7402C58.7476 44.2577 57.5174 45.4878 56 45.4878V39.9927ZM25.0572 44.6831C23.9842 43.6101 23.9842 41.8704 25.0572 40.7974L42.5427 23.3119C43.6157 22.2389 45.3553 22.2389 46.4283 23.3119C47.5013 24.3849 47.5013 26.1246 46.4283 27.1976L30.8857 42.7402L46.4283 58.2829C47.5013 59.3559 47.5013 61.0956 46.4283 62.1686C45.3553 63.2416 43.6157 63.2416 42.5427 62.1686L25.0572 44.6831ZM56 45.4878H27V39.9927H56V45.4878Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.4833cc918a3e62b6e3988a1edacadff8.svg";
export { ForwardRef as ReactComponent };